import { render, staticRenderFns } from "./DocCascader.vue?vue&type=template&id=dbaeed3c&scoped=true&"
import script from "./DocCascader.vue?vue&type=script&lang=js&"
export * from "./DocCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaeed3c",
  null
  
)

export default component.exports